import { lazy } from "react";

const Customers = lazy(() => import("../pages/customers/Customers"));
const CreateCustomer = lazy(() => import("../pages/customers/CreateCustomer"));
const CustomerDetails = lazy(
  () => import("../pages/customers/CustomerDetails")
);
const EditCustomer = lazy(() => import("../pages/customers/EditCustomer"));
const CustomerInvoices = lazy(
  () => import("../pages/customers/CustomerInvoices")
);
const DependentsPrompt = lazy(
  () => import("../pages/customers/dependents/DependentsPrompt")
);
const CreateDependent = lazy(
  () => import("../pages/customers/dependents/CreateDependent")
);
const DependentsDetails = lazy(
  () => import("../pages/customers/dependents/DependentsDetails")
);
const EditDependent = lazy(
  () => import("../pages/customers/dependents/EditDependent")
);
const Measurements = lazy(
  () => import("../pages/customers/measurements/Measurements")
);
const MeasurementDetails = lazy(
  () => import("../pages/customers/measurements/MeasurementDetails")
);
const CreateMeasurement = lazy(
  () => import("../pages/customers/measurements/CreateMeasurement")
);
const EditMeasurement = lazy(
  () => import("../pages/customers/measurements/EditMeasurement")
);

export const customersRoutes = [
  {
    path: "/customers",
    component: Customers,
  },
  {
    path: "/customers/new-customer",
    component: CreateCustomer,
  },
  {
    path: "/customers/:id",
    component: CustomerDetails,
  },
  {
    path: "/customers/edit/:id",
    component: EditCustomer,
  },
  {
    path: "/customers/:id/invoices",
    component: CustomerInvoices,
  },
  // Dependents Routes
  {
    path: "/customers/dependents/dependents-prompt/:id",
    component: DependentsPrompt,
  },
  {
    path: "/customers/create-dependent/:id",
    component: CreateDependent,
  },
  {
    path: "/customers/:id/dependents/:dependentId",
    component: DependentsDetails,
  },
  {
    path: "/customers/edit/:id/dependents/:dependentId",
    component: EditDependent,
  },
  // Measurement Routes
  {
    path: "/customers/:id/measurements",
    component: Measurements,
  },
  {
    path: "/customers/:id/measurements/:measurementId",
    component: MeasurementDetails,
  },
  {
    path: "/customers/:id/create-measurement",
    component: CreateMeasurement,
  },
  {
    path: "/customers/edit/:id/measurements/:measurementId",
    component: EditMeasurement,
  },
];
